require(['jquery', 'utils', 'mojo-analytics'], function ($, utils, MojoAnalytics) {


  if (window.location.pathname === '/mobile/') {
    MojoAnalytics.sendEvent({
      eventName: 'Viewed Mobile Landing Page',
      eventData: {
        ref: utils.getURLParameter('ref'),
      },
    });
  }

  $('#playimage').click(function () {
    MojoAnalytics.sendEvent({
      eventName: 'Viewed Mobile App in Play Store',
      eventData: {
        source: 'main_landing',
        homepage_location: utils.getURLParameter('ref'),
      },
    });
  });

  $('#phone_number').keydown(function () {
    $('#failure').addClass('hide');
  });

  $('#send-sms-form').submit(function (e) {
    e.preventDefault();
    var mobile = $('#phone_number').val();
    var number = '+91' + mobile;

    if (mobile.match(/^\(?([7-9]{1})\)?([0-9]{9})$/)) {
      MojoAnalytics.sendEvent({
        eventName: 'Requested Mobile App Link',
        eventData: {
          phone: number,
          homepage_location: utils.getURLParameter('ref'),
        },
      });

      $.ajax({
        url: '/webapi/mobile-app-sms-invite/',
        type: 'POST',
        cache: false,
        data: { phone_number: mobile },
        headers: {
          'X-CSRFTOKEN': utils.getCookie('csrftoken'),
        },
      })
        .done(function (data) {
          $('#send-sms-form').addClass('hide');
          $('#success').removeClass('hide').text(data.message);
        })
        .fail(function (jqXHR) {
          $('#failure').removeClass('hide').text(JSON.parse(jqXHR.responseText).error);
        });
    }
    else {
      var errorText = 'Please enter a valid number.';
      if (!mobile) {
        errorText = 'Enter mobile number.';
      }
      $('#failure').removeClass('hide').text(errorText);
    }
  });
});

define("android-landing", function(){});

